import { all, select, call, put } from 'redux-saga/effects';
import pick from 'lodash/pick';
import { withOffset, selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { FetchType } from '@wix/da-shared-react/pkg/Stream/base/types';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { galleryFolderSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/folder';
import { isApiError } from '@wix/da-http-client';
import { ShopItemType } from '../../../types/shop';
import { PapiCommissionsRequestParams } from '../../../types/papi';
import { getRequestParams } from '../../selectors/pageInfo';
import { getProfileOwner } from '../../selectors/users';
import { SHOP_PARAMS_SENT_TO_PAPI } from '../../store/initActions/shop';
import { requestPuppyGruser } from '../gruserHelpers';

function* fetchFromApi(shopItemType, params) {
  return yield call(
    requestPuppyGruser,
    {
      method: 'get',
      url: `/module/${shopItemType}`,
      params,
    },
    undefined,
    'gruser'
  );
}

export default function* fetchMoreShopItems(action) {
  const { streamId } = action;
  try {
    const [requestParams, offset, limit, streamParams, profileOwner] = yield all([
      select(getRequestParams),
      select(state => withOffset.selectors.getNextOffset(state, streamId)),
      select(state => streamSelectors.getItemsPerFetch(state, streamId)),
      select(state => streamSelectors.getStreamParamsSafe(state, streamId)),
      select(getProfileOwner),
    ]);

    const previousShopParams = pick(requestParams, SHOP_PARAMS_SENT_TO_PAPI);

    const newParams: PapiCommissionsRequestParams = {
      ...previousShopParams,
      username: profileOwner.user && profileOwner.user.username,
      moduleid: streamParams.moduleId,
      offset,
      limit,
    };

    const shopItemType: ShopItemType = streamParams.shopItemType;

    const response = yield call(fetchFromApi, shopItemType, newParams);
    if (!response || isApiError(response)) {
      yield put(withOffset.actions.fetchFailure({ streamId, fetchType: FetchType.Next }));
      return;
    }

    const { hasMore, total, nextOffset, results } = response;

    const schema =
      streamParams.shopItemType === ShopItemType.PREMIUM_FOLDERS
        ? galleryFolderSchema
        : deviationSchema;
    const { result, entities } = normalize(results, [schema]);

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: result,
        total,
        entities,
      })
    );
  } catch {
    yield put(withOffset.actions.fetchFailure({ streamId, fetchType: FetchType.Next }));
  }
}
